"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _camelCase = _interopRequireDefault(require("../poly/camelCase"));
var _keys = _interopRequireDefault(require("../poly/keys"));
var getStyles = function getStyles(variant, palette) {
  return (0, _keys.default)(palette.button[variant]).reduce(function (styles, color) {
    var rest = (0, _extends3.default)({}, palette.button[variant][color]);
    return (0, _extends3.default)({}, styles, (0, _defineProperty2.default)({}, (0, _camelCase.default)([variant, color]), (0, _extends3.default)({}, rest, {
      fill: rest.color
    })));
  }, {
    classNamePrefix: 'TCUIBadge'
  });
};
var buildTextStyles = function buildTextStyles(palette) {
  return (0, _extends3.default)({
    text: {
      display: 'inline',
      minHeight: 'initial',
      minWidth: 'initial',
      letterSpacing: '0.1px',
      textAlign: 'left',
      padding: 0,
      color: palette.text.primary,
      fill: palette.text.primary
    }
  }, getStyles('text', palette));
};
var buildContainedStyles = function buildContainedStyles(palette) {
  return (0, _extends3.default)({
    contained: {
      borderWidth: '2px',
      borderStyle: 'solid',
      color: palette.button.contained.primary.color,
      fill: palette.button.contained.primary.color,
      background: palette.button.contained.primary.background,
      borderColor: palette.button.contained.primary.border
    }
  }, getStyles('contained', palette));
};
var buildOutlineStyles = function buildOutlineStyles(palette) {
  return (0, _extends3.default)({
    outline: {
      borderWidth: '2px',
      borderStyle: 'solid',
      color: palette.button.outline.primary.color,
      fill: palette.button.outline.primary.color,
      background: palette.button.outline.primary.background,
      borderColor: palette.button.outline.primary.border
    }
  }, getStyles('outline', palette));
};
var useClasses = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return (0, _extends3.default)({
    root: {
      padding: '0.4em .75em',
      display: 'inline-flex'
    }
  }, buildTextStyles(palette), buildContainedStyles(palette), buildOutlineStyles(palette));
});
var Badge = function Badge(_ref2) {
  var _clsx;
  var variant = _ref2.variant,
    color = _ref2.color,
    classes = _ref2.classes,
    children = _ref2.children;
  var _classes = useClasses();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(_classes.root, _classes[variant], (_clsx = {}, (0, _defineProperty2.default)(_clsx, _classes[(0, _camelCase.default)([variant, color])], !!variant && !!color), (0, _defineProperty2.default)(_clsx, classes.root, !!classes), _clsx))
  }, children);
};
Badge.propTypes = {
  color: _propTypes.default.oneOf(['primary', 'secondary', 'tertiary']),
  children: _propTypes.default.node,
  classes: _propTypes.default.object,
  variant: _propTypes.default.oneOf(['text', 'contained', 'outline'])
};
Badge.defaultProps = {
  color: 'primary',
  variant: 'contained',
  children: null,
  classes: {}
};
var _default = Badge;
exports.default = _default;